import { createStore, applyMiddleware, compose, Middleware } from 'redux';
import appReducers, { AppState } from 'app/reducers';
import { Action } from './actions';
import { logger } from './middleware';

export type { AppState } from 'app/reducers';

const middlewares: Middleware[] = [];
let composeEnhancers = compose;

if (typeof window !== 'undefined') {
  middlewares.push(logger);
  composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
}

const store = createStore(
  appReducers,
  composeEnhancers(applyMiddleware(...middlewares)),
);

export function currentState(): AppState {
  return store.getState();
}

export function dispatch(action: Action) {
  store.dispatch(action);
}

export const setupStore = (initialState?: AppState) => {
  return createStore(
    appReducers,
    initialState,
    composeEnhancers(applyMiddleware(...middlewares)),
  );
};

export default store;
